import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "835b85d4-caef-473e-908d-9f3e17ad69cf", content: "It is heard as a distinct echo.", options: {} },
  { id: "03ed43e0-6884-4c15-853e-b2f278e75ef1", content: "It has no audible effect.", options: {} },
  { id: "6561fc46-a010-4066-a817-459502db1142", content: "It creates undesirable<br>tone colouration.", options: {} },
  {
    id: "e5d7fefb-4e14-492c-986a-cfeee44305eb",
    content: "It increases the apparent<br>loudness of the source.",
    options: {},
  },
];

export const task: Task = {
  id: "c8ee8f28-ae3d-41dd-bef3-3f1eaebc8483",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["6561fc46-a010-4066-a817-459502db1142"],
};
